import ErrorsMessages from '@portal/enum/errors';

type ErrorResolverParams = {
  err: { message: string };
  fallbackKey: string;
};

const validateErrorMessage = (message: string) => {
  return [
    ErrorsMessages.TRANSACTION_NOT_APPROVED,
    ErrorsMessages.TRANSACTION_LAST_ATTEMPT_BEFORE_BLOCK,
    ErrorsMessages.TRANSACTION_FINAL_ATTEMPT,
    ErrorsMessages.BLOCKED_ACCOUNT,
  ].includes(message.toLowerCase() as ErrorsMessages);
};

export const pinValidationResolver = ({
  err,
  fallbackKey,
}: ErrorResolverParams) => {
  const isPinError = validateErrorMessage(err.message);

  return {
    message: isPinError ? err.message.toUpperCase() : fallbackKey,
    isPinError,
  };
};
